import { gamePresentationOf } from "@softmax/web-features/coworlds";
import { buildHref, matchRoute } from "@softmax/web-addresses";

import { type GamePageContext } from "../../game-types";
import { onePagerCoworldOf } from "@/features/play/state";

import { type AdmissionDecision } from "./admission.types";

const retiredHomeTabs = new Set([
  "heroes",
  "items",
  "guide",
  "players",
  "standings",
]);

function isRetiredHomeTab({
  url,
  game,
}: {
  url: URL;
  game: GamePageContext | null;
}): boolean {
  const [, tab, ...rest] = url.pathname
    .replace(/^\/unlisted(?=\/)/, "")
    .split("/")
    .slice(1);
  return (
    game?.corpusSlug === "gods-of-the-arena" &&
    tab !== undefined &&
    rest.length === 0 &&
    retiredHomeTabs.has(tab)
  );
}

export function gameAliasAdmission({
  url,
  game,
}: {
  url: URL;
  game: GamePageContext | null;
}): AdmissionDecision | null {
  if (!game) return null;

  const route = matchRoute(url.pathname);
  const presentation = gamePresentationOf(game.corpusSlug);
  const retiredPreview =
    route.name === "game.preview" &&
    !route.league &&
    presentation.home === "store";

  if (
    isRetiredHomeTab({
      url,
      game,
    }) ||
    retiredPreview
  ) {
    return {
      kind: "navigate",
      navigation: {
        kind: "path",
        pathname: buildHref({ name: "game.home", game: game.address }),
        status: 308,
      },
    };
  }

  if (route.name === "game.start" && onePagerCoworldOf(game.corpusSlug)) {
    return {
      kind: "navigate",
      navigation: {
        kind: "path",
        pathname: buildHref({
          name: "game.play",
          game: game.address,
          league: route.league,
        }),
        status: 308,
      },
    };
  }

  return null;
}
